import React, { Component } from "react";
import { connect } from "react-redux";
import CertificatePic from "../TutorApplicationForm/CertificatePic";
import Backend from "react-dnd-html5-backend";
import DraggableComponent from "./../../components/DraggableComponent";
import { DndProvider } from "react-dnd";
import { updateTutorSettings, getSetting } from "../../apis/tutors";
import { TutorSettingAction } from "./../../redux/actions";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import { Row, Col, Image, Button } from "react-bootstrap";
import { InfoModal } from "./../../components/modals/InfoModal";

class TutorSettingbackgroundCheck extends Component {
  constructor() {
    super();
    this.state = {
      typeOfDocument: 0,
      authorizeToRunBgCheck: false,
      frontOfCardUrl: "",
      backOfCardUrl: "",
      dBSCertUrl: "",
      country: "United kingdom",
      imageErrorMessage: "",
      certificateError: false,
      showAlert: false,
      show: false,
      show1: false,
    };
  }

  componentDidMount = () => {
    let {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
    } = this.state;
    const { tutorSettingData } = this.props;
    let verificationDoc = tutorSettingData?.tutorDetails?.verificationDoc;
    typeOfDocument = verificationDoc?.typeOfDocument
      ? verificationDoc?.typeOfDocument
      : "";
    authorizeToRunBgCheck = verificationDoc?.authorizeToRunBgCheck
      ? verificationDoc?.authorizeToRunBgCheck
      : "";
    frontOfCardUrl = verificationDoc?.frontOfCardUrl
      ? verificationDoc?.frontOfCardUrl
      : "";
    backOfCardUrl = verificationDoc?.backOfCardUrl
      ? verificationDoc?.backOfCardUrl
      : "";
    dBSCertUrl = verificationDoc?.dBSCertUrl ? verificationDoc?.dBSCertUrl : "";
    this.setState({
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
    });
  };

  componentDidUpdate = (prevProps) => {
    let {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
    } = this.state;
    const { tutorSettingData } = this.props;
    if (
      JSON.stringify(prevProps.tutorSettingData) !==
      JSON.stringify(tutorSettingData)
    ) {
      let verificationDoc = tutorSettingData?.tutorDetails?.verificationDoc;
      typeOfDocument = verificationDoc?.typeOfDocument
        ? verificationDoc?.typeOfDocument
        : "";
      authorizeToRunBgCheck = verificationDoc?.authorizeToRunBgCheck
        ? verificationDoc?.authorizeToRunBgCheck
        : "";
      frontOfCardUrl = verificationDoc?.frontOfCardUrl
        ? verificationDoc?.frontOfCardUrl
        : "";
      backOfCardUrl = verificationDoc?.backOfCardUrl
        ? verificationDoc?.backOfCardUrl
        : "";
      dBSCertUrl = verificationDoc?.dBSCertUrl
        ? verificationDoc?.dBSCertUrl
        : "";
      this.setState({
        typeOfDocument,
        authorizeToRunBgCheck,
        frontOfCardUrl,
        backOfCardUrl,
        dBSCertUrl,
      });
    }
  };
  updateIdenticationDetail = () => {
    let user = JSON.parse(localStorage.getItem("userDetail"));
    let user_id = user.user.userId;
    const {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
    } = this.state;
    let updateSettingParam = {
      updateSetting: {
        verificationDoc: {
          typeOfDocument,
          authorizeToRunBgCheck,
          frontOfCardUrl,
          backOfCardUrl,
          dBSCertUrl,
        },
      },
    };

    updateTutorSettings(updateSettingParam)
      .then((res) => {
        getSetting({ user_id })
          .then((res) => {
            InfoModal("Updates", "Successfully Update");
            this.setState({
              loader: false,
            });
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };

  show = (e) => {
    e.preventDefault();
    this.setState({
      show: true,
    });
  };
  hide = (e) => {
    e.preventDefault();
    this.setState({
      show: false,
    });
  };

  handleChange = (checked) => {
    this.setState({
      authorizeToRunBgCheck: !checked,
    });
  };


  onSave = () => {
    const { CertificatePic } = this.state;
    return CertificatePic
      ? this.setState({
          show: false,
        })
      : this.setState({
          certifError: true,
        });
  };
  render() {
    const {
      authorizeToRunBgCheck,
      dBSCertUrl,
      certificateError,
      show,
      certifError,
    } = this.state;

    return (
      <div className="container">
        <Row className="tutor-setting-Identification flex-center-center">
          <Col lg={8} md={8} sm={12} xs={12} className="subject-mode setting-identification">
            <SettingHeader
              settingName={"Background check"}
              headerTitle={"Background check"}
              headerDesciption={" Update your ID or provide us with the enhanced DBS or PVG certificates."}
              goToAccount={() => this.props.history.push("/tutor-setting")}
            />
            {!show ? (
              <div>
                <div
                  className="flex-between-center"
                >
                  <label className="label">
                    {" "}
                    DBS or Criminal record certificate
                  </label>
                  <a
                    className={`btn-a ${show ? "gray-link" : "green-link"}`}
                    onClick={this.show}
                  >
                    ADD
                  </a>
                </div>
                {dBSCertUrl ? (
                  <p className="Text-messages">PDF File</p>
                ) : (
                  <p className="Text-messages">Not provided.</p>
                )}

                <hr className="mt-5 mb-5" />
              </div>
            ) : (
              ""
            )}

            {show ? (
              <div>
                <div
                  className="flex-between-center"
                  style={{ marginBottom: "20px" }}
                >
                  <label className="label">
                    Add your background check Certificate
                  </label>
                  <a className="btn-a" onClick={this.hide}>
                    Cancel
                  </a>
                </div>
                <p className="Text-messages">
                  You do not need a background check to use our platform tutor,
                  however you may miss on opportunities where students or parents
                  require you to have a background check certificate. All tutors
                  who upload a copy of their enhanced background check certificate
                  such as the DBS or PVG will be awarded a verification badge on
                  their tutor profile and have access all tutoring jobs within
                  their speciality.
                </p>
                <label className="label">Your certificate</label>
                <p className="Text-messages">
                  Upload a colour copy of your enhanced DBS or PVG certificate
                  which has been issued within the last 2 years
                </p>
                <div
                  className={`${!dBSCertUrl && certifError ? "imageError" : ""}`}
                >
                  <DndProvider backend={Backend}>
                    <DraggableComponent
                      TargetChildComponent={CertificatePic}
                      certificateError={certificateError}
                      ImageUploadAction={this.props.ImageUploadAction}
                      uploadedImage={this.props.uploadImage}
                      errorMessagehandling={(error) => {
                        this.setState({
                          ...this.state,
                          certificateError: error,
                        });
                        setTimeout(() => {
                          this.setState({
                            ...this.state,
                            certificateError: false,
                          });
                        }, 1000);
                      }}
                      updateImageUrl={(e) =>
                        this.setState({
                          ...this.state,
                          dBSCertUrl: e,
                        })
                      }
                      imageUrl={dBSCertUrl}
                      typeNo={"3"}
                    />
                  </DndProvider>
                  {!dBSCertUrl && certifError ? (
                    <div
                      style={{
                        color: "#fa4a4a",
                        fontSize: "12px",
                        marginBottom: "10px",
                      }}
                      className="flex-start-center"
                    >
                      <Image
                        src={require("./../../assets/icons/info.png")}
                        style={{ marginRight: "10px" }}
                      />
                      Please add certificate
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <p className="small-text certfcate_small-p">
                  <i className="mdi mdi-lock mr-1"></i>Your certificate is used to
                  verify and award you with a badge on your tutor profile and is
                  not shared with other users of Askademia
                </p>
                <p className="Text-messages">
                  We request updates from the{" "}
                  <span style={{ color: "#2cb46d" }}>DBS update service</span>{" "}
                  periodically to keep your DBS status updated. Other users of
                  Askademia will not see this information.
                </p>
                <div className="custom-control custom-checkbox mb-3 cerfcate_check">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheck61"
                    checked={authorizeToRunBgCheck}
                    onChange={() => {
                      this.handleChange(authorizeToRunBgCheck);
                    }}
                  />
                  <label
                    className="custom-control-label Text-messages"
                    htmlFor="customCheck61"
                    style={{
                      cursor: "pointer",
                      marginBottom: "0px",
                      fontSize: "14px",
                    }}
                  >
                    By checking this box you authorise Askademia running your DBS
                    Check through the DBS Update Service
                  </label>
                  {!authorizeToRunBgCheck ? (
                    this.props?.validationError?.data?.authorizeToRunBgCheck ? (
                      <div className="red-alert-message">
                        {this.props?.validationError?.data?.authorizeToRunBgCheck}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex- mb-4">
                  <Button
                    className="green-save-btn"
                    onClick={this.onSave}
                    style={{
                      width: "104px",
                      height: "56px",
                      borderRadius: "5px",
                      backgroundColor: "#2cb46d",
                      fontSize: "16px",
                      fontWeight: "600",
                      marginTop: "10px",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            ) : (
              ""
            )}
            <Button
              style={{
                width: "104px",
                height: "56px",
                borderRadius: "5px",
                backgroundColor: "#2cb46d",
                fontSize: "16px",
                fontWeight: "600",
                marginTop: "10px",
              }}
              className="green-Button"
              onClick={this.updateIdenticationDetail}
            >
              Update
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;

  return {
    tutorSettingData,
  };
};
const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToprops
)(TutorSettingbackgroundCheck);
